module.exports = __webpack_public_path__ + "dash_20_app_assets/img/trustpilothow.f2c0835c.png";